// ENTITY fr.gestionpial.pial.dto.AeshDetailDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { Ecole } from './Ecole';
import { Aesh } from './Aesh';
import { PreferenceAesh } from './PreferenceAesh';
import { AbsenceAesh } from './AbsenceAesh';
import { AffectationAesh } from './AffectationAesh';
import { AeshVolumePeriode } from './AeshVolumePeriode';

export class AeshDetailDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.AeshDetailDTO';

  aesh: Aesh | null = null;
  affectations: AffectationAesh[] | null = [];
  absences: AbsenceAesh[] | null = [];
  ecoles: Ecole[] | null = [];
  historiqueAffectations: AffectationAesh[] | null = [];
  preferences: PreferenceAesh[] | null = [];
  volumePeriodes: AeshVolumePeriode[] | null = [];
  idsEcolesInterdites: number[] | null = [];
  ecolesInterdites: Ecole[] | null = [];
  idsEcolesPrioritaires: number[] | null = [];
  ecolesPrioritaires: Ecole[] | null = [];
  minutesPlanifiees: number | null = 0;

  constructor(init?:Partial<AeshDetailDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.AeshDetailDTO'] = AeshDetailDTO;

fields['fr.gestionpial.pial.dto.AeshDetailDTO']  = {
    aesh: 'fr.gestionpial.pial.entities.Aesh',
    affectations: 'java.util.List<fr.gestionpial.pial.entities.AffectationAesh>',
    absences: 'java.util.List<fr.gestionpial.pial.entities.AbsenceAesh>',
    ecoles: 'java.util.List<fr.gestionpial.pial.entities.Ecole>',
    historiqueAffectations: 'java.util.List<fr.gestionpial.pial.entities.AffectationAesh>',
    preferences: 'java.util.List<fr.gestionpial.pial.entities.PreferenceAesh>',
    volumePeriodes: 'java.util.List<fr.gestionpial.pial.entities.AeshVolumePeriode>',
    idsEcolesInterdites: 'java.util.List<java.lang.Integer>',
    ecolesInterdites: 'java.util.List<fr.gestionpial.pial.entities.Ecole>',
    idsEcolesPrioritaires: 'java.util.List<java.lang.Integer>',
    ecolesPrioritaires: 'java.util.List<fr.gestionpial.pial.entities.Ecole>',
    minutesPlanifiees: 'java.lang.Integer'
};
